"use client";

import { Slot } from "@radix-ui/react-slot";
import type { PropsWithChildren } from "react";

import { TabsProvider } from "./TabsContext";
import useTab from "./useTab";

export const Tab = ({
  children,
  tabId,
}: PropsWithChildren<{ tabId: string }>) => {
  const currentTab = useTab(tabId);
  if (currentTab?.isActive) return <Slot>{children}</Slot>;
  else return null;
};

export const Trigger = ({
  children,
  tabId,
}: PropsWithChildren<{ tabId: string }>) => {
  const currentTab = useTab(tabId);
  if (!currentTab) return null;
  return (
    <Slot data-active={currentTab.isActive} onClick={currentTab.toggle}>
      {children}
    </Slot>
  );
};

export const Tabs = ({
  tabIds,
  children,
}: PropsWithChildren<{ tabIds: string[] }>) => (
  <TabsProvider tabIds={tabIds}>{children}</TabsProvider>
);
